'use strict';
import React, {Component} from 'react';
import * as T from 'prop-types';
import classNames from 'classnames';
import {I18nComponent} from '../../../core-utilities/react-i18n/I18nComponent';
import {SvgIcon} from '../../../core-components/svg-menu-icons/SvgIcon';
import {SvgIcons} from '../../../core-components/svg-menu-icons/icons';

export function BaseFilterInputView(props) {
  return (
    <div className={classNames("FilterInput", {"FilterInput_focused": props.isFocused})}>
      <i
        className="FilterInput__icon icon ion-ios-search-strong"
        title={props.searchTitle}
      />
      <label>
        <input
          className="FilterInput__input"
          id="search-filter"
          type="search"
          placeholder={props.searchPlaceholder}
          value={props.model}
          onChange={props.onFilterChange}
          onBlur={props.onInputBlur}
          onFocus={props.onInputFocus}
        />
      </label>
      {!props.searchOnly && (
        <i
          className={classNames('FilterInput__filterBtn not-default-filter-options', {
            'not-default-show': !props.matchesDefaultOptions,
            'not-default-pulse': props.isAnimating,
            'visibility-btn': props.searchOnly,
          })}
          onClick={props.onClickFilterOptions}
          title={props.filterTitle}
        >
          <SvgIcon
            className="FilterInput__filterBtn__svgIcon"
            icon={SvgIcons.SearchOptions}
          />
        </i>
      )}
    </div>
  );
}

BaseFilterInputView.propTypes = {
  model: T.string,
  searchOnly: T.bool,
  matchesDefaultOptions: T.bool,
  isFocused: T.bool,
  searchTitle: T.string,
  filterTitle: T.string,
  isAnimating: T.bool,

  onFilterChange: T.func.isRequired,
  onInputBlur: T.func.isRequired,
  onInputFocus: T.func.isRequired,
  onClickFilterOptions: T.func,
};

export const FilterInputView = I18nComponent(BaseFilterInputView, [
  {code: 'icon.search.title', prop: 'searchTitle'},
  {code: 'icon.filter.title', prop: 'filterTitle'},
  {code: 'search.placeholder', prop: 'searchPlaceholder'},
]);



// WEBPACK FOOTER //
// ./src/js/components/lists/FilterInput/FilterInputView.js